import React from 'react';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { Battery, CellularConnection, Wifi } from '../../../../../../../assets/svgs';
import { useSelector } from 'react-redux';
import { translate } from '../../../../../../../utils/language';

let today = new Date();
let dd = String(today.getDate()).padStart(2, '0');
let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
let yy = String(today.getFullYear()).slice(-2);

let formattedDate = dd + '/' + mm + '/' + yy;

function AppBarBase({ item, AppBarComponent, activeThemePage }) {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);

  const customization = staticComponentValueConverter(item?.customization);

  return (
    <div
      className="w-full flex flex-col align-center justify-center relative p-2 gap-[15px]"
      style={{
        backgroundColor: customization?.backgroundColor,
        borderBottomRightRadius: customization?.bottomRadius,
        borderBottomLeftRadius: customization?.bottomRadius,
        padding: staticValues[12] + 'px',
        gap: staticValues[12] + 'px',
      }}
    >
      <div className="flex flex-row border-1 border-gray-200 rounded-lg justify-between p-2">
        <div className="flex flex-col">
          <div
            className="font-semibold text-[14px] text-start"
            style={{ marginBottom: staticValues[8] + 'px', color: 'var(--secondaryThemeColor)' }}
          >
            Test
          </div>
          <div
            className="font text-[12px]"
            style={{ marginBottom: staticValues[8] + 'px', color: 'var(--secondaryThemeColor)' }}
          >
            Test
          </div>
        </div>
        <div
          className="flex text-[9px]"
          style={{
            color: 'var(--secondaryThemeColor)',
          }}
        >
          {formattedDate}
        </div>
      </div>
      <div className="flex flex-row border-1 border-gray-200 rounded-lg justify-between p-2">
        <div className="flex flex-col">
          <div
            className="font-semibold text-[14px] text-start"
            style={{ marginBottom: staticValues[8] + 'px', color: 'var(--secondaryThemeColor)' }}
          >
            Test
          </div>
          <div
            className="font text-[12px]"
            style={{ marginBottom: staticValues[8] + 'px', color: 'var(--secondaryThemeColor)' }}
          >
            Test
          </div>
        </div>
        <div
          className="flex text-[9px]"
          style={{
            color: 'var(--secondaryThemeColor)',
          }}
        >
          {formattedDate}
        </div>
      </div>
    </div>
  );
}

export default AppBarBase;
